/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OrderJobTickets_order$ref: FragmentReference;
declare export opaque type OrderJobTickets_order$fragmentType: OrderJobTickets_order$ref;
export type OrderJobTickets_order = {|
  +id: string,
  +$refType: OrderJobTickets_order$ref,
|};
export type OrderJobTickets_order$data = OrderJobTickets_order;
export type OrderJobTickets_order$key = {
  +$data?: OrderJobTickets_order$data,
  +$fragmentRefs: OrderJobTickets_order$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "OrderJobTickets_order",
  "type": "Order",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8a269d38b86cbbe8ef5fe515da7eab90';
module.exports = node;
